<script lang="ts">
import { MessageContentType, MessageSubType } from '@smartsupp/smartsupp-message'
import { setContext } from 'svelte'
import { writable } from 'svelte/store'

import AgentMessage from '@/components/content/AgentMessage.svelte'
import BotMessage from '@/components/content/BotMessage.svelte'
import BotMessageReplies from '@/components/content/BotMessageReplies.svelte'
import BotMessageTicketSubmit from '@/components/content/BotMessageTicketSubmit.svelte'
import ContactMessage from '@/components/content/ContactMessage.svelte'
import SystemMessage from '@/components/content/SystemMessage.svelte'
import TriggerMessage from '@/components/content/TriggerMessage.svelte'
import {
	contentListItemKey,
	type MessageContext,
	MessageGroupType,
	type WritableMessageContext,
} from '@/modules/messages'

type Props = {
	context: MessageContext
}

let { context }: Props = $props()

let writableContext = writable(context)
setContext<WritableMessageContext>(contentListItemKey, writableContext)

$effect(() => {
	$writableContext !== context && writableContext.set(context)
})
let { group, message } = $derived(context)
</script>

{#if message.subType === MessageSubType.Contact}
	<ContactMessage />
{:else if message.subType === MessageSubType.Agent}
	<AgentMessage />
{:else if message.subType === MessageSubType.System}
	{#if group.type === MessageGroupType.BotReplies}
		<BotMessageReplies />
	{:else}
		<SystemMessage />
	{/if}
{:else if message.subType === MessageSubType.Bot}
	{#if message.content.type === MessageContentType.TicketForm && group.type !== MessageGroupType.BotReplies}
		<BotMessageTicketSubmit />
	{:else if group.type === MessageGroupType.BotMessage}
		<BotMessage />
	{:else if group.type === MessageGroupType.BotReplies}
		<BotMessageReplies />
	{/if}
{:else if message.subType === MessageSubType.Trigger}
	<TriggerMessage />
{/if}
